module.exports = __webpack_public_path__ + "img/hoverBg.8384f88e.png";